"use client";
import { useEffect, useRef } from "react";

// Module-level — survives client-side navigation, keeping the video playing
// from where it was rather than restarting on every page transition.
let savedTime = 0;

export function VideoPlayer({ mp4, poster, className }: { mp4: string; poster: string; className?: string }) {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    if (savedTime > 0) v.currentTime = savedTime;

    const onUpdate = () => { savedTime = v.currentTime; };
    v.addEventListener("timeupdate", onUpdate);
    return () => {
      savedTime = v.currentTime;
      v.removeEventListener("timeupdate", onUpdate);
    };
  }, []);

  return (
    <video
      ref={ref}
      className={className}
      poster={poster}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      aria-hidden
    >
      <source src={mp4} type="video/mp4" />
    </video>
  );
}
